import OnePanelSection from './OnePanelSection';

export default OnePanelSection;